import { render, staticRenderFns } from "./api-items.vue?vue&type=template&id=6fb20dc4&"
import script from "./api-items.vue?vue&type=script&lang=js&"
export * from "./api-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports